import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col,Popover} from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { QuestionCircleOutlined ,DownloadOutlined} from '@ant-design/icons';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;
var contentlist;

class Top10MovieCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}
	
	async componentDidUpdate(prevProps) {
	}



	render() {
		const { opensearchTop10MovieList, opensearchMovieList } = this.props;
		cc_data = opensearchTop10MovieList || [];
		cc_data = cc_data.sort((a, b) => b.doc_count - a.doc_count);
		
		contentlist = opensearchMovieList || [];
		
		// let contenttitle = "";
		function getPoster(contentid){
			let poster = require('../../../src/static/no_image.jpg');
			contentlist.forEach(c => {
				if(c._source && c._source.contentId && c._source.imageLandscape && c._source.contentId === contentid){
					poster =  c._source.imageLandscape;
					// contenttitle = c._source.metadata[0]? c._source.metadata[0].title : "";
				}				
			})
			return poster;
		};
		
		// let dataset = [];
		// cc_data.map((d) => {
		// 	let temp = [];
		// 	temp.push(d.contentTitle.buckets[0].key,d.doc_count);
		// 	dataset.push(temp);
		// });
		// const option = {
		// 	dataset: {
		// 		source: dataset
		// 	  },
		// 	grid: { containLabel: true },
		// 	toolbox: {
		// 		showTitle: false,
		// 	  show: true,
		// 	  orient: 'vertical',
		// 	  left: 'right',
		// 	  top: 'center',
		// 	  feature: {
		// 		mark: { show: true },
		// 		dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
		// 		magicType: { show: true, type: ['line'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
		// 		restore: { show: true, title:'Refresh' },
				
		// 	  }
		// 	},
		// 	tooltip: {
		// 	  trigger: 'axis',
		// 	  formatter: function (data) {
		// 		data = data[0];
		// 		return `${cc_data[data.dataIndex].key}, Views: ${cc_data[data.dataIndex].doc_count}<br/> ${cc_data[data.dataIndex].contentTitle.buckets[0].key}<br/> <img src="${getPoster(cc_data[data.dataIndex].key)}"  style="width:140px;height:100px;">`;},
		// 	  axisPointer: {
		// 		type: 'shadow'
		// 	  }
		// 	},
		// 	xAxis: { type: 'value' },
		// 	yAxis: { type: 'category' },
		// 	series: [
		// 	  {
		// 		type: 'bar'
		// 	  }
		// 	]
		//   };
		  const settings = {
			focusOnSelect: true,
			infinite: false,
			variableWidth: true,
			slidesToScroll: 1,
			speed: 500,
		  };

		return (
			<Card className="analyticCard portraitPoster">
				<h3 className="title">{`Top 10 Movies  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10MovieCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map((c,k) => ({ items: k+1 , content_title: c.contentTitle.buckets[0]?c.contentTitle.buckets[0].key:'' ,content_id : c.key, count:c.doc_count}))} target="_blank" filename={"Top 10 Movies.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<Slider   {...settings}>
							{
								cc_data.map((d, k) =>(
									<div key= 'poster' className='portaitPoster'>
										<div key='image' className='portaitPoster image'><img alt="" src={getPoster(d.key)}  style={{width:'100%' }}></img></div>
										<div key='title' className='portaitPoster detail'><p className="portaitPoster title">#{k+1}  {d.contentTitle.buckets[0]?d.contentTitle.buckets[0].key:''}</p></div>
										<div key='views' className='portaitPoster detail'><p className="portaitPoster view">{d.doc_count} views</p></div>
									</div>
									)
									
								)
							}
						
						</Slider>
						{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} /> */}
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	opensearchTop10MovieList: state.analytics.opensearchTop10MovieList,
	selectedOrganization: state.user.selectedOrganization,
	opensearchMovieList : state.analytics.opensearchMovieList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10MovieCard));
